(function () {
  function updateUCEntries(sectionId, variantId) {
    const mapEl = document.getElementById(`UCEntriesMap-${sectionId}`);
    const valueEl = document.getElementById(`UCEntriesValue-${sectionId}`);
    if (!mapEl || !valueEl || !variantId) return;

    let map;
    try {
      map = JSON.parse(mapEl.textContent || "{}");
    } catch {
      return;
    }

    const row = map[String(variantId)] || {};
    const fallback = valueEl.getAttribute("data-fallback") || "";

    if (row.note) {
      valueEl.textContent = row.note;
    } else if (row.mult) {
      valueEl.textContent = `${row.mult}× entries`;
    } else {
      valueEl.textContent = fallback;
    }
  }

  function getCurrentVariantIdFromForm(sectionId) {
    // Dawn typically keeps current variant id in a hidden input name="id"
    const scope = document.getElementById(`ProductInfo-${sectionId}`) || document;
    const idInput = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
    return idInput ? idInput.value : null;
  }

  // Listen for changes on variant inputs (works even if Dawn event names differ)
  document.addEventListener("change", (e) => {
    const productInfo = e.target.closest('[id^="ProductInfo-"]');
    if (!productInfo) return;

    const sectionId = productInfo.id.replace("ProductInfo-", "");
    const variantId = getCurrentVariantIdFromForm(sectionId);
    updateUCEntries(sectionId, variantId);
  });

  // Also run once on page load for safety
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[id^="ProductInfo-"]').forEach((el) => {
      const sectionId = el.id.replace("ProductInfo-", "");
      const variantId = getCurrentVariantIdFromForm(sectionId);
      updateUCEntries(sectionId, variantId);
    });
  });
})();